<template>
<div class="has-navbar-fixed-top">
    <nav class="navbar is-fixed-top"><SideMenu></SideMenu>
      <h1 class="title">Credits</h1>
    </nav>
    <section class="section">
      <div class="container">
        <div class="edition subtitle">Second Edition composed by</div>
        <ul class="credits">
          <li v-for="person in secondEdition" :key="person.name">
            <div v-if="person.and">and</div>
            <span class="role" v-if="person.role">{{person.role}} - </span>
            <component class="name" :is="person.link?'a':'span'" :href="person.link || ''" target="_blank">
              {{person.name}}
            </component>
          </li>
        </ul>
        <div class="edition subtitle">First Edition composed by</div>
        <ul class="credits">
          <li v-for="person in firstEdition" :key="person.name">
            <div class="and" v-if="person.and">and</div>
            <span class="role" v-if="person.role">{{person.role}} - </span>
            <component class="name" :is="person.link?'a':'span'" :href="person.link || ''" target="_blank">
              {{person.name}}
            </component>
          </li>
        </ul>
        <div class="react">
          The first edition of These Pages Fall Like Ash was funded by the <a href="http://www.react-hub.org.uk/" target="_blank">REACT Hub</a> in Bristol.
          <br>Our eternal thanks are ever due.
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import credits from '@/credits'
export default {

  name: 'FAQs',

  data () {
    return {
    }
  },
  computed: {
    secondEdition () {
      return credits.filter((p) => {
        return p.editions.includes(2)
      })
    },
    firstEdition () {
      return credits.filter((p) => {
        return p.editions.includes(1)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  text-align: left;
  .edition{
  }
  .credits{
    margin-bottom: 1em;
  }
  .name {
  }
  .and {
  }
  .role {
    font-style: italic;
  }
}
.header {
  text-align: center;
}
.has-navbar-fixed-top {
  padding-top: 3em;
}
nav h1 {
  padding: 26px 0 10px 0;
  left: 0px;
  right: 0px;
  margin:auto;
}

</style>
